/**
 * Badge component for connection status indicators
 */

type BadgeColor = "green" | "yellow" | "blue" | "red" | "gray";

interface BadgeProps {
  readonly color: BadgeColor;
  readonly children: string;
  readonly className?: string;
}

const dotClasses: Record<BadgeColor, string> = {
  green: "bg-accent-green",
  yellow: "bg-status-warning",
  blue: "bg-accent-blue",
  red: "bg-status-error",
  gray: "bg-text-muted",
};

export function Badge({ color, children, className = "" }: BadgeProps) {
  return (
    <div className={`flex items-center justify-center gap-2 ${className}`}>
      <div className={`h-2 w-2 rounded-full ${dotClasses[color]}`} />
      <span className="text-text-secondary text-xs">{children}</span>
    </div>
  );
}
